/** Brief 12, K3 - AI yordamchi va K3 - AI sozlamalari (русский). */
export const ruB12Ai = {
  "yordamchi.title": "AI-ассистент",
  "yordamchi.scope.operator": "По вашим клиентам и сделкам",
  "yordamchi.scope.manager": "По вашему филиалу",
  "yordamchi.scope.owner": "По всем филиалам",
  "yordamchi.new": "Новый диалог",
  "yordamchi.hello": "Здравствуйте, {name}. Чем помочь?",
  "yordamchi.intro": "Спросите о сделке, клиенте, брони или платеже. Ответы берутся из данных Kapitan, источник указывается.",
  "yordamchi.searching": "Ищу данные…",
  "yordamchi.placeholder": "Напишите вопрос",
  "yordamchi.questionLabel": "Вопрос AI-ассистенту",
  "yordamchi.send": "Отправить",
  "yordamchi.sg.todayOperator": "Что мне сделать сегодня?",
  "yordamchi.sg.debtsOperator": "У каких клиентов есть долг?",
  "yordamchi.sg.offers": "Шарм, варианты на 8–15 ноября",
  "yordamchi.sg.docs": "Какие документы нужны в Египет?",
  "yordamchi.sg.todayBranch": "Что важно сегодня в филиале?",
  "yordamchi.sg.debts": "Список должников",
  "yordamchi.today": "Что AI сделал сегодня",
  "yordamchi.todayCount": "Действий: {count}",
  "yordamchi.todayEmpty": "Сегодня AI ещё не работал.",
  "yordamchi.approve": "Отправить",
  "yordamchi.reject": "Отклонить",
  "yordamchi.sent": "Сообщение поставлено в очередь отправки",
  "yordamchi.rejected": "Черновик отклонён",
  "yordamchi.whyReject": "Почему отклонили?",
  "yordamchi.reason.wrong": "Неверные данные",
  "yordamchi.reason.tone": "Тон",
  "yordamchi.reason.needless": "Не нужно",
  "yordamchi.reason.other": "Другое",
  "yordamchi.permissions": "Разрешения",
  "yordamchi.perm.afterHours": "Автоответ в нерабочее время",
  "yordamchi.perm.afterHoursSub": "Собирает вопросы, цену не называет",
  "yordamchi.perm.proposal": "Отправка вариантов без подтверждения",
  "yordamchi.perm.proposalSub": "Если выключено, подтверждает оператор",
  "yordamchi.perm.comment": "Ответы на комментарии в Instagram",
  "yordamchi.perm.commentSub": "Только вопросы о цене и датах",
  "yordamchi.perm.discount": "Предложение скидки",
  "yordamchi.perm.discountSub": "Скидку даёт только оператор: это правило платформы",
  "yordamchi.credits": "Кредиты: {total}",
  "yordamchi.creditsOf": "Кредиты: {total} / {monthly}",
  "yordamchi.creditsDays": " · ~{days} дн.",
  "yordamchi.topUp": "Пополнить",
  "yordamchi.permOn": "{name}: включено",
  "yordamchi.permOff": "{name}: выключено",
  "yordamchi.draftOpen": "Записано в открытый черновик. Опубликуйте его в матрице подтверждений.",
  "yordamchi.emptyTitle": "AI-ассистент ещё не настроен",
  "yordamchi.emptyMessage": "Когда будут заполнены данные агентства, требования к документам и быстрые ответы, AI будет отвечать на их основе.",
  "yordamchi.emptyAction": "К настройкам",
  "yordamchi.errorTitle": "AI-ассистент не ответил",
  "yordamchi.errorMessage": "Сервер не ответил. Введённые данные сохранены, страницу можно безопасно перезагрузить.",
  "yordamchi.general": "Без источника",
  "yordamchi.knowledgeSource": "База знаний",

  "aiS.nav": "Разделы AI-агента",
  "aiS.page.overview": "Обзор",
  "aiS.page.files": "Файлы",
  "aiS.page.settings": "Матрица подтверждений",
  "aiS.page.journal": "Дневник",
  "aiS.page.playground": "Песочница",
  "aiS.page.tests": "Центр тестов",
  "aiS.page.memory": "Предложения памяти",
  "aiS.page.knowledge": "База знаний",
  "aiS.page.posts": "Посты Instagram",
  "aiS.readOnly": "Менеджер · только просмотр. Изменения вносит владелец.",
  "aiS.denied": "{role} видит в AI-агенте только «Посты Instagram». При необходимости напишите владельцу агентства.",
  "aiS.toPosts": "Посты Instagram",
  "aiS.title": "AI-агент",

  "aiS.status": "Статус",
  "aiS.st.active": "Активен",
  "aiS.st.observe": "Режим наблюдения",
  "aiS.st.stopped": "Остановлен",
  "aiS.st.broken": "Не работает",
  "aiS.st.activeText": "AI отвечает сам согласно матрице подтверждений.",
  "aiS.st.observeText": "AI пока ничего не отправляет. Просмотрите ответы в очереди подтверждения, затем переведите в автоматический режим.",
  "aiS.st.stoppedText": "AI остановлен на всех каналах. Диалоги переданы операторам.",
  "aiS.st.stoppedReason": "Причина: {reason}",
  "aiS.st.brokenText": "Не настроено — Платформа → Интеграции → LLM",
  "aiS.observe": "Режим наблюдения",
  "aiS.observeHint": "AI готовит ответ, но не отправляет. Всё попадает в очередь подтверждения. Новое агентство начинает в этом режиме; в автоматический переводит только владелец.",
  "aiS.stop": "Экстренная остановка",
  "aiS.stopHint": "AI сразу замолкает на всех каналах, диалоги переходят к операторам.",
  "aiS.stopConfirm": "Остановить",
  "aiS.stopReason": "Причина (необязательно)",
  "aiS.stopDone": "AI остановлен. Диалогов передано операторам: {count}",
  "aiS.resume": "Включить AI снова",
  "aiS.resumed": "AI включён. Диалоги автоматически не возвращаются.",
  "aiS.cancel": "Отмена",
  "aiS.channels": "Пауза по каналам",
  "aiS.ch.telegram": "Telegram",
  "aiS.ch.instagram": "Instagram Direct",
  "aiS.ch.comment": "Комментарии Instagram",
  "aiS.ch.accounts": "Аккаунтов: {count}",
  "aiS.ch.posts": "Активных постов: {count}",
  "aiS.ch.none": "Не подключён",
  "aiS.ch.paused": "На паузе",
  "aiS.credits": "AI-кредиты",
  "aiS.billing": "Биллинг",
  "aiS.creditsOf": "/ {monthly}",
  "aiS.creditsDays": " · хватит на ~{days} дн.",
  "aiS.creditsToday": "Сегодня {today} кредитов · в среднем {average} в день",
  "aiS.summary": "Итог дня",
  "aiS.toJournal": "Дневник",
  "aiS.summaryEmpty": "Итог дня появится после первого диалога.",
  "aiS.sum.first": "Ответил в диалогах: {count}.",
  "aiS.sum.firstSpeed": "Ответил в диалогах: {count}, первый ответ в среднем за {seconds} с.",
  "aiS.sum.qualified": "Квалифицировано лидов: {count}.",
  "aiS.sum.handoffs": "Передал оператору: {count}",
  "aiS.sum.blocked": "Ответов остановлено проверками: {count}",
  "aiS.tasks": "Задачи",
  "aiS.schedule": "Расписание",
  "aiS.taskToday": "сегодня {count}",
  "aiS.open": "Открыть",
  "aiS.tasksEmpty": "Задачи ещё не настроены.",
  "aiS.task.sales": "Первый ответ, квалификация, получение телефона, до предложения",
  "aiS.task.comments": "Открытый ответ на посты и одно личное сообщение",
  "aiS.task.service": "Напоминания перед поездкой, отзыв после возвращения",
  "aiS.task.assist": "Черновик, резюме, подсказка следующего вопроса",
  "aiS.task.analytics": "Сводка дня, напоминание о просроченном платеже",
  "aiS.task.custom": "Собственная задача агентства",

  "aiS.fu.title": "Правила follow-up",
  "aiS.fu.subtitle": "Kapitan AI сам создаёт задачу и пишет причину",
  "aiS.fu.example": "Пример: «Вчера отправлен вариант, ответа нет» · задача появится в Задачах и на Главной со значком Kapitan AI.",
  "aiS.fu.after": "через",
  "aiS.fu.every": "каждые",
  "aiS.fu.days": "дн.",
  "aiS.fu.minutes": "мин.",
  "aiS.fu.switch": "{name}: включить",
  "aiS.fu.followup_offer_silent.t": "Нет ответа после предложения",
  "aiS.fu.followup_offer_silent.d": "Клиент видел вариант, но не написал · задача на повторный контакт",
  "aiS.fu.followup_not_interested.t": "После «Не заинтересовался»",
  "aiS.fu.followup_not_interested.d": "Задача написать снова с другим направлением или датой",
  "aiS.fu.followup_ai_off_reminder.t": "Напоминание в диалогах «AI выключен»",
  "aiS.fu.followup_ai_off_reminder.d": "Напоминает, если оператор не отвечает · через 3 часа менеджеру",
  "aiS.fu.followup_morning_list.t": "Список каждое утро",
  "aiS.fu.followup_morning_list.d": "В {time} каждому оператору список follow-up на сегодня",
  "aiS.fu.saved": "{name}: сохранено",

  "aiS.files.title": "Файлы",
  "aiS.files.subtitle": "AI работает по инструкциям из этих файлов. Каждая публикация создаёт новую версию; номер под ответами и есть эта версия.",
  "aiS.files.tab.rol": "Роль",
  "aiS.files.tab.xulq": "Поведение",
  "aiS.files.tab.bilim": "Знания",
  "aiS.files.tab.iboralar": "Фразы",
  "aiS.files.tab.xotira": "Память",
  "aiS.files.tab.limitlar": "Лимиты",
  "aiS.files.edit": "Редактор",
  "aiS.files.diff": "Разница",
  "aiS.files.diffOf": "Разница v{from} – v{to}",
  "aiS.files.merged": "Общий вид",
  "aiS.files.versions": "Версии",
  "aiS.files.current": "текущая",
  "aiS.files.draft": "черновик",
  "aiS.files.restore": "Вернуться к версии v{n}",
  "aiS.files.restoreCurrent": "Текущая версия",
  "aiS.files.restored": "v{n} взята в черновик. До публикации на клиентов не влияет.",
  "aiS.files.save": "Сохранить в черновик",
  "aiS.files.saved": "Сохранено в черновик",
  "aiS.files.publish": "Опубликовать · v{n}",
  "aiS.files.published": "Опубликовано. Действует со следующих ответов.",
  "aiS.files.noDiff": "Отличий от предыдущей версии нет.",
  "aiS.files.bilimHint": "Файл знаний состоит из записей, он редактируется в базе знаний.",
  "aiS.files.toKb": "База знаний",
  "aiS.files.noFile": "Настроек агента ещё нет.",
  "aiS.persona.title": "Персона и тон",
  "aiS.persona.warm": "Вежливо",
  "aiS.persona.middle": "Средне",
  "aiS.persona.short": "Кратко",
  "aiS.persona.intro": "Представляться в первом сообщении",
  "aiS.persona.introSub": "Пишет «помощник {name}»",
  "aiS.persona.quiet": "Тихие часы",
  "aiS.persona.quietText": "{from} – {to} · проактивные сообщения не отправляются, на вопросы отвечает",
  "aiS.persona.quietNone": "Часы работы филиала не указаны · AI работает круглосуточно",
  "aiS.persona.wait": "Пауза перед ответом",
  "aiS.persona.waitHint": "сек. · если клиент пишет подряд, ответит на всё сразу",
  "aiS.persona.flow.new": "Новое обращение",
  "aiS.persona.flow.clarify": "Уточнение",
  "aiS.persona.flow.offer": "Предложение",
  "aiS.persona.flow.negotiate": "Переговоры",
  "aiS.persona.flow.pay": "Оплата",
  "aiS.persona.flow.after": "После продажи",
  "aiS.persona.flow": "Flow · до какого этапа работает AI",
  "aiS.persona.flowHint": "Стандарт: до предложения AI; переговоры и оплата у человека; послепродажная часть включена.",
  "aiS.persona.ai": "AI",
  "aiS.persona.human": "человек",
  "aiS.persona.saved": "Сохранено в черновик. Не забудьте опубликовать.",
  "aiS.persona.phrases": "Библиотека фраз",
  "aiS.persona.more": "Подробные настройки",

  "aiS.matrix.title": "Матрица подтверждений",
  "aiS.matrix.subtitle": "Какое сообщение AI отправляет сам (Авто), а какое ждёт подтверждения оператора (Подтверждение). Ожидающие попадают в Диалоги → Очередь подтверждения.",
  "aiS.matrix.kind": "Тип сообщения",
  "aiS.matrix.auto": "Авто",
  "aiS.matrix.approve": "Подтверждение",
  "aiS.matrix.locked": "Всегда с подтверждением · изменить нельзя",
  "aiS.matrix.kind.reply": "Ответ",
  "aiS.matrix.kind.proactive": "Проактивное сообщение",
  "aiS.matrix.kind.proposal": "Предложение",
  "aiS.matrix.kind.reminder": "Напоминание",
  "aiS.matrix.kind.requisites": "Платёжные реквизиты",
  "aiS.matrix.publish": "Опубликовать",
  "aiS.matrix.published": "Настройки опубликованы",
  "aiS.matrix.commentOnly": "Комментарий может быть только ответом",
  "aiS.matrix.channels": "Режим аккаунта",
  "aiS.matrix.versions": "Версии настроек",
  "aiS.matrix.rollBack": "Вернуть",
  "aiS.matrix.rolledBack": "Возвращена предыдущая версия",

  "aiS.journal.title": "Дневник",
  "aiS.journal.subtitle": "Что AI сделал сегодня, что запланировано и где были проблемы.",
  "aiS.journal.all": "Все",
  "aiS.journal.feed": "Лента действий",
  "aiS.journal.credits": "Кредитов: {count}",
  "aiS.journal.detail": "Детали работы AI",
  "aiS.journal.input": "Входящее сообщение",
  "aiS.journal.inputNone": "— (по расписанию)",
  "aiS.journal.tools": "Использованные инструменты",
  "aiS.journal.toolsNone": "Инструменты не использовались",
  "aiS.journal.kb": "База знаний",
  "aiS.journal.guard": "Проверка",
  "aiS.journal.guardOk": "Прошло проверку",
  "aiS.journal.settings": "Настройки",
  "aiS.journal.settingsV": "Версия {id}",
  "aiS.journal.close": "Закрыть",
  "aiS.journal.plan": "Запланированные работы",
  "aiS.journal.planEmpty": "Запланированных работ нет",
  "aiS.journal.problems": "Проблемы",
  "aiS.journal.problemsEmpty": "Сегодня проблем нет",
  "aiS.journal.emptyTitle": "Сегодня AI ещё не работал",
  "aiS.journal.emptyMessage": "AI остановлен или новых сообщений не было.",
  "aiS.journal.yesterday": "Посмотреть вчера",
  "aiS.journal.backToday": "Вернуться к сегодня",
  "aiS.journal.summary": "Сегодня ответов: {runs}, передач: {handoffs}. Остановлено ответов: {blocked}. Кредитов: {credits}.",

  "aiS.play.title": "Песочница",
  "aiS.play.subtitle": "Пишите как клиент · AI отвечает с текущими настройками. Сообщения никому не отправляются, кредиты не тратятся.",
  "aiS.play.scenario": "Сценарий:",
  "aiS.play.placeholder": "Напишите как клиент…",
  "aiS.play.version": "Версия",
  "aiS.play.live": "Текущая версия",
  "aiS.play.draft": "Черновик №{n}",
  "aiS.play.send": "Отправить",
  "aiS.play.why": "Почему такой ответ?",
  "aiS.play.hide": "Скрыть",
  "aiS.play.empty": "Напишите сообщение как клиент или выберите сценарий.",
  "aiS.play.ai": "AI · версия {n}",

  "aiS.tests.title": "Центр тестов",
  "aiS.tests.subtitle": "Тестовые случаи проверяют ожидаемое поведение AI. После изменения настроек запустите массовый тест.",
  "aiS.tests.run": "Запустить все тесты",
  "aiS.tests.summary": "Прошло {passed} · не прошло {failed}",
  "aiS.tests.never": "Ещё не запускались",
  "aiS.tests.compare": "Сравнение:",
  "aiS.tests.case": "Случай",
  "aiS.tests.expected": "Ожидаемое поведение",
  "aiS.tests.passed": "прошёл",
  "aiS.tests.failed": "не прошёл",
  "aiS.tests.none": "—",
  "aiS.tests.empty": "Тестовых случаев нет.",
  "aiS.tests.blocked": "Важный тест не прошёл: публикация заблокирована",

  "aiS.memory.title": "Предложения памяти",
  "aiS.memory.subtitle": "AI предлагает новые правила на основе правок операторов. Принятое записывается в файл памяти.",
  "aiS.memory.basis": "Основание: операторы делали так {count} раз",
  "aiS.memory.accept": "Принять",
  "aiS.memory.edit": "Изменить",
  "aiS.memory.reject": "Отклонить",
  "aiS.memory.saveAccept": "Сохранить и принять",
  "aiS.memory.empty": "Новых предложений нет",
  "aiS.memory.accepted": "Записано в черновик. До публикации на клиентов не влияет.",

  "aiS.kb.title": "База знаний",
  "aiS.kb.subtitle": "AI отвечает, опираясь только на эти данные. Запись с истёкшим сроком отключается автоматически.",
  "aiS.kb.upload": "Загрузить документ",
  "aiS.kb.add": "Запись",
  "aiS.kb.endless": "бессрочно",
  "aiS.kb.until": "действует до: {date}",
  "aiS.kb.expired": "срок истёк",
  "aiS.kb.accept": "Принять",
  "aiS.kb.empty": "В этой коллекции нет записей.",
  "aiS.kb.gaps": "Вопросы без ответа",
  "aiS.kb.gapsHint": "AI не нашёл ответа",
  "aiS.kb.gapTimes": "{count} раз",
  "aiS.kb.gapAdd": "Добавить ответ",
  "aiS.kb.valid": "Срок действия",
  "aiS.kb.file": "Файл (.docx или .pdf)",

  "aiS.posts.title": "Посты Instagram",
  "aiS.posts.subtitle": "Карточка поста говорит AI, как отвечать на комментарии: направление, акция, примечание.",
  "aiS.posts.warn": "Постов без карточки, но с множеством комментариев: {count}",
  "aiS.posts.warnText": "AI отвечает в общем виде, направление и акция неизвестны.",
  "aiS.posts.dest": "Направление",
  "aiS.posts.promo": "Акция",
  "aiS.posts.state": "Статус",
  "aiS.posts.note": "Для AI",
  "aiS.posts.meta": "Комментариев: {count}",
  "aiS.posts.create": "Создать карточку",
  "aiS.posts.edit": "Изменить",

  "aiS.task.back": "AI-агент",
  "aiS.task.procedures": "Процедуры",
  "aiS.task.addProcedure": "+ Процедура",
  "aiS.task.behaviour": "Поведение задачи",
  "aiS.task.tools": "Инструменты и разрешения",
  "aiS.task.toolOff": "запрещено",
  "aiS.task.toolDraft": "только с подтверждением",
  "aiS.task.toolAuto": "по матрице",
  "aiS.task.routine": "Расписание и лимит",
  "aiS.task.jobs": "Запланированные работы",
  "aiS.task.share": "Доля кредитов",
  "aiS.task.sharePct": "% дневного лимита",
  "aiS.task.proc": "Процедура: {name}",
  "aiS.task.procNew": "Новая процедура",
  "aiS.task.procName": "Название",
  "aiS.task.when": "КОГДА",
  "aiS.task.do": "ЧТО ДЕЛАТЬ",
  "aiS.task.addWhen": "+ Добавить условие",
  "aiS.task.addDo": "+ Добавить шаг",
  "aiS.task.whenPrefix": "ЕСЛИ",
  "aiS.task.whenAnd": "И",
  "aiS.task.whenPlaceholder": "Условие",
  "aiS.task.doPlaceholder": "Шаг",
  "aiS.task.remove": "Удалить",
  "aiS.task.test": "Проверить",
  "aiS.task.save": "Сохранить",
  "aiS.task.saved": "Процедура записана в черновик",
  "aiS.task.testNeeds": "Проверить нельзя: нужно хотя бы одно условие и один шаг.",
  "aiS.task.testing": "Результат проверки",
  "aiS.task.notFound": "Такая задача не найдена.",
  "aiS.task.runNow": "Запустить сейчас",
  "aiS.task.jobStarted": "Работа запущена",
  "aiS.task.noJobs": "Для этой задачи нет расписания.",
  "aiS.task.saveBehaviour": "Сохранить поведение",
} as const;
